import { useState, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import SignUpForm from '@/components/auth/SignUpForm'
import SignInForm from '@/components/auth/SignInForm'
import ForgotPasswordForm from '@/components/auth/ForgotPasswordForm'
import Container from '@/components/common/Container'
import Card from '@/components/common/Card'

function Auth() {
  const [searchParams] = useSearchParams()
  const tab = searchParams.get('tab')
  const [isSignUp, setIsSignUp] = useState(tab !== 'signin' && tab !== 'forgot-password')
  const [isForgotPassword, setIsForgotPassword] = useState(tab === 'forgot-password')
  const navigate = useNavigate()

  // Update form when URL changes
  useEffect(() => {
    if (tab === 'signin') {
      setIsSignUp(false)
      setIsForgotPassword(false)
    } else if (tab === 'signup') {
      setIsSignUp(true)
      setIsForgotPassword(false)
    } else if (tab === 'forgot-password') {
      setIsSignUp(false)
      setIsForgotPassword(true)
    }
  }, [tab])

  return (
    <div className="min-h-screen bg-brand-cream py-12">
      <Container>
        <div className="max-w-md mx-auto">
          <Card>
            <div className="text-center mb-6">
              <h1 className="font-heading text-3xl font-bold mb-2">
                {isForgotPassword ? 'Reset Your Password' : isSignUp ? 'Create Your Account' : 'Welcome Back'}
              </h1>
              <p className="text-brand-slate">
                {isForgotPassword
                  ? 'Enter your email to receive a reset link'
                  : isSignUp
                    ? 'Start saving time with your team communication'
                    : 'Sign in to your account'}
              </p>
            </div>

            {isForgotPassword ? (
              <ForgotPasswordForm onSuccess={() => setIsForgotPassword(false)} />
            ) : isSignUp ? (
              <SignUpForm onSuccess={() => navigate('/team-setup')} />
            ) : (
              <SignInForm onSuccess={() => navigate('/dashboard')} />
            )}
            
            {!isForgotPassword && (
              <div className="mt-6 text-center">
                <button
                  onClick={() => {
                    setIsSignUp(!isSignUp)
                    setIsForgotPassword(false)
                  }}
                  className="text-brand-green hover:underline"
                >
                  {isSignUp
                    ? 'Already have an account? Sign in'
                    : "Don't have an account? Sign up"}
                </button>
              </div>
            )}

            {isForgotPassword && (
              <div className="mt-6 text-center">
                <button
                  onClick={() => {
                    setIsSignUp(false)
                    setIsForgotPassword(false)
                  }}
                  className="text-brand-green hover:underline"
                >
                  Back to sign in
                </button>
              </div>
            )}
          </Card>
        </div>
      </Container>
    </div>
  )
}

export default Auth


